import * as React from 'react';
import Helmet from 'react-helmet';
import { showHeaderAndMenu } from '../../core/session';

const PageTitle = (props: Props) => {
	return (
		<>
			{showHeaderAndMenu() && (
				<>
					<Helmet>
						<title>{props.title}</title>
					</Helmet>
					<h1 className="pageTitle">{props.title}</h1>
				</>
			)}
		</>
	);
};

interface Props {
	title: string;
}

export default PageTitle;
